import { dateToView } from "helpers/date";
import {
    integrationSubscriptionStates,
    integrationSubscriptionStatesEnum,
} from "helpers/enums/integrationSubscriptionStates";
import { enumLabel } from "helpers/system";
import React from "react";
import type { IntegrationSubscription } from "sources/billing";

/** Show partner subscription details and the unmodified payment URL supplied by billing. */
export default function IntegrationSubscriptionCard({ subscription }: { subscription: IntegrationSubscription }) {
    const { state, offerId, vehicleLimit, startsAt, endsAt, paidAt, paymentUrl, isPaymentAvailable } = subscription;
    const rows = [
        ["Статус", enumLabel(integrationSubscriptionStates, state)],
        ["Тариф", offerId ?? "—"],
        ["Доступное количество машин", vehicleLimit ?? "—"],
        ["Начало подписки", startsAt ? dateToView(startsAt) : "—"],
        ["Окончание подписки", endsAt ? dateToView(endsAt) : "—"],
        ...(paidAt ? [["Дата оплаты", dateToView(paidAt)]] : []),
    ];

    return (
        <div className="card card-body col-lg-6">
            <h5>Подписка CARGO.RUN</h5>
            <p className="text-muted">Оплата через АТИ</p>
            <table className="table table-sm">
                <tbody>
                    {rows.map(([label, value]) => (
                        <tr key={label}>
                            <th scope="row">{label}</th>
                            <td className="text-right">{value}</td>
                        </tr>
                    ))}
                </tbody>
            </table>
            {isPaymentAvailable && paymentUrl && (
                <a className="btn btn-brand align-self-start" href={paymentUrl} target="_blank" rel="noreferrer">
                    {state === integrationSubscriptionStatesEnum.Active ? "Продлить подписку" : "Перейти к оплате"}
                </a>
            )}
        </div>
    );
}
